module.exports = __webpack_public_path__ + "img/IMG_2499-2.794f9d5e.jpg";